'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

exports.initializeHighstocks = initializeHighstocks;

var _log = require('./log');

var log = _interopRequireWildcard(_log);

var _environment = require('./environment');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Asynchronous loading of the highcharts library.
 * This method allows delaying the loading of the library files until they are needed.
 * The function returns a Promise that resolves to the highcharts Object.
 *
 * This combines the techniques that are used to asynchronously load webpack chunks
 * and the non-standard initialization of highcharts that is needed when loading it
 * from the npm module.
 *
 * If there are path issues with loading this (or any other async chunk), then check
 * the public path in the webpack configuration first.
 *
 * @example
 * loadHighchartsAsync().then(Highcharts => {
 *      const chart = Highcharts.chart(this.$refs.chart, {
 *          series: [{ data: [1,3,2,4,5] }]
 *      });
 *      console.log(chart);
 * });
 *
 * @see https://webpack.js.org/guides/code-splitting/#dynamic-imports
 * @see https://www.npmjs.com/package/highcharts
 *
 * TODO At the moment async chunks have been disabled because of mixed loading and caching results. Revisit this in the future!
 *
 * @returns {Promise.<TResult>}
 */
function initializeHighstocks() {
    if (_highchartsLoadingPromise) {
        return _highchartsLoadingPromise;
    }

    _highchartsLoadingPromise = _promise2.default.resolve([require('highcharts/highstock'), require('highcharts/modules/exporting'), require('../configurations/highcharts/global.json'), require('../configurations/highcharts/global.pdf.json')]);

    // Async version below
    // _highchartsLoadingPromise = Promise.all([
    //     import(/* webpackChunkName: "highcharts.async" */ 'highcharts/highstock'),
    //     import(/* webpackChunkName: "highcharts.async" */ 'highcharts/modules/exporting'),
    //     import(/* webpackChunkName: "highcharts.async" */ '../configurations/highcharts/global.json')
    // ])

    _highchartsLoadingPromise = _highchartsLoadingPromise.then(function (_ref) {
        var _ref2 = (0, _slicedToArray3.default)(_ref, 4),
            Highstock = _ref2[0],
            highchartInit = _ref2[1],
            globalOptions = _ref2[2],
            pdfOptions = _ref2[3];

        log.info('initializeHighstocks', Highstock, highchartInit, globalOptions, pdfOptions);

        // Initialize the highcharts library
        highchartInit(Highstock);

        // Set global options
        Highstock.setOptions(globalOptions);

        if ((0, _environment.isPdf)()) {
            Highstock.setOptions(pdfOptions);
        }

        return Highstock;
    }, function (e) {
        return log.error(e);
    });

    return _highchartsLoadingPromise;
}

/**
 * Variable that is used to cache the loading promise.
 */
var _highchartsLoadingPromise = void 0;